import React from "react";
import { CFormGroup, CLabel } from "@coreui/react";
import { get } from "lodash";
import { ErrorText, InfoTooltip, RichTextEditor } from "src/components";

const TextInput = ({
  handleChange,
  name,
  value,
  errors,
  label,
  info,
  labelClassname,
  className,
}) => {
  return (
    <CFormGroup className={className}>
      <CLabel htmlFor={name} className={labelClassname}>
        {label}
        {!!info && <InfoTooltip content={info} />}
      </CLabel>
      <RichTextEditor
        id={name}
        value={value}
        onChange={(val) => {
          if (val || val === "") {
            handleChange({
              target: {
                name,
                value: val,
              },
            });
          }
        }}
      />
      {errors && <ErrorText value={get(errors, name)} />}
    </CFormGroup>
  );
};

export default TextInput;
